import styled, { css } from 'styled-components';

export const WrapperCounter = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: flex-start;
    gap: 4px;
    background-color: ${theme.v2.colors.neutral.highPure};
  `}
`;

export const CounterBoxes = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
  `}
`;

export const TimeBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    padding: 6px 9px;
    border: 0.5px solid ${theme.v2.colors.neutral.highMedium};
    border-radius: 5px;
    min-width: 32px;
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
  `}
`;

export const Title = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    background: linear-gradient(94deg, #2E93EE 1.9%, #2E93EE 5.89%, #415ACA 40.83%, #5421A5 77.87%, #551CA2 83%, #2E1451 116.37%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-top: 0;
    margin-right: 12px;
  `}
`;

export const Label = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowPure};
    margin-top: 3px;
  `}
`;

export const Separator = styled.span`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    display: flex;
    align-items: center;
    height: 30px;
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
  `}
`;
